module.exports = __webpack_public_path__ + "img/quyu.69b36ad1.png";